import { ExperienceUI } from "./ExperienceUI";
import { Canvas } from "./Canvas/Canvas";
export class App {
  constructor() {
    this.UI = new ExperienceUI();
    this.canvas = new Canvas();

    this.addEventListeners();
  }

  addEventListeners() {
    this.UI.on("trackSelected", (track) => {
      this.canvas.visualizer.createMesh();
      this.canvas.visualizer.onTrackSelected(track);
    });
  }
}
